import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { AttributeModel } from 'src/app/shared/models/attribute.model';

@Component({
    standalone: false,
    selector: 'app-attributes-popup',
    templateUrl: './attributes-popup.component.html',
    styleUrls: ['./attributes-popup.component.scss']
})
export class AttributesPopupComponent implements OnInit {
    links: AttributeModel[];
    description: string;
    assumption: AttributeModel;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    get isAssumptionEnabled(): boolean {
        return _.get(this, 'assumption.IsEnabled', false);
    }

    get assumptionValue(): string {
        return _.get(this, 'assumption.AttributeValue', '');
    }

    ngOnInit(): void {
        this.links = this.data.attributes.filter(attribute => attribute.isLink);
        this.assumption = this.data.attributes.find(attribute => attribute.isAssumption);
        this.description = this.data.description;
    }

}
